import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { Form } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import { EventToast } from "./Toast";
import { useGroupNotify, GroupNotification } from "../hooks/useGroupNotify";

// Some warning threshholds for push notifications
// const PUSH_TITLE_RECOMMENDED_CHARS = 45;
// const PUSH_BODY_RECOMMENDED_CHARS = 110;
// const PUSH_BODY_RECOMMENDED_LINES = 4;

export interface EventNotification {
	Method: "push" | "email";
	Title: string;
	Body: string;
	Groups: string[];
	SendAt?: string;
	From?: string;
}
type NotifyResultData = {
	show: boolean;
	msg: string;
};

interface EventNotifyProps {
	show: boolean;
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	groups: any[];
	onNotifySent: (data: NotifyResultData) => void;
	onCloseModal: (modalStatus: boolean) => void;
}

export const EventNotifyModal: React.FC<EventNotifyProps> = ({
	show,
	groups,
	onNotifySent,
	onCloseModal,
}) => {
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	const { sendToGroups, notificationSending } = useGroupNotify();
	const [showToast, setShowToast] = useState(false);
	const [showNotificationModal, setShowNotificationModal] = useState(show);
	const [notificationTitle, setNotificationTitle] = useState("");
	const [notificationBody, setNotificationBody] = useState("");
	const [notifyResult, setNotifyResult] = useState("");
	const handleCloseNotificationModal = () => {
		setNotificationTitle("");
		setNotificationBody("");
		setShowNotificationModal(false);
		onCloseModal(false);
	};
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	const handleSetNotificationTitle = (e: any) =>
		setNotificationTitle(e.target.value);
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	const handleSetNotificationBody = (e: any) =>
		setNotificationBody(e.target.value);

	const handleValidation = () => {
		if (notificationTitle.trim() === "" || notificationBody.trim() === "") {
			return false;
		}
		return true;
	};

	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	const handleSendNotification = async (_e: any) => {
		if (handleValidation()) {
			let notification: GroupNotification = {
				Method: "push",
				Groups: groups,
				Title: notificationTitle,
				Body: notificationBody,
				From: "",
			};
			console.log("Notification:", notification);
			const result = await sendToGroups(notification);
			let msg = "";
			console.log("Result: ", result);
			if (result && result?.status === "ok") {
				msg = `${result?.message}`;
				if (result?.result?.send_count) {
					// Add message count if available
					msg += ` - [ ${result?.result?.send_count} ]`;
				}
			} else {
				// displayMsg(`Could not send emails. ${result.message}`, {
				// 	type: "danger",
				// 	position: "middle",
				// });
			}
			setShowNotificationModal(false);
			setNotifyResult(msg);
			setNotificationBody("");
			setNotificationTitle("");

			setShowToast(true);
			// eslint-disable-next-line @typescript-eslint/no-unused-vars
			const timeoutId = setTimeout(() => {
				console.log("Function ran after 5000 ms");
				setShowToast(false);
			}, 5000);
		}
	};

	useEffect(() => {
		setShowNotificationModal(show);
	}, [show]);

	useEffect(() => {
		onNotifySent({
			show: false,
			msg: notifyResult,
		});
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [notifyResult]);

	return (
		<>
			<Modal
				centered
				show={showNotificationModal}
				onHide={handleCloseNotificationModal}
				size="lg"
			>
				<Modal.Header closeButton>
					<Modal.Title>Send App Notification </Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<Form>
						<Form.Group className="mb-3">
							<Form.Label>Title</Form.Label>
							<Form.Control
								type="text"
								autoFocus
								onChange={handleSetNotificationTitle}
								value={notificationTitle}
							/>
							{notificationTitle.trim() === "" && (
								<Form.Text className="text-danger ">
									Please enter a notification title
								</Form.Text>
							)}
						</Form.Group>
						<Form.Group className="mb-3">
							<Form.Label>Body</Form.Label>
							<Form.Control
								as="textarea"
								rows={3}
								value={notificationBody}
								onChange={handleSetNotificationBody}
							/>
							{notificationBody.trim() === "" && (
								<Form.Text className="text-danger ">
									Please enter notification text
								</Form.Text>
							)}
						</Form.Group>
					</Form>
				</Modal.Body>
				<Modal.Footer>
					<Button
						size="sm"
						variant="primary"
						onClick={handleSendNotification}
						disabled={
							notificationTitle.trim() === "" || notificationBody.trim() === ""
						}
					>
						Send
					</Button>
					<Button
						size="sm"
						variant="secondary"
						onClick={handleCloseNotificationModal}
					>
						Cancel
					</Button>
				</Modal.Footer>
			</Modal>
			<EventToast
				delay={5000}
				title={"Event Manager"}
				message={"Notification sent"}
				show={showToast}
			/>
		</>
	);
};
